(() => {
  if (customElements.get('hartfield-product-copy')) return;
  class HartfieldProductCopy extends HTMLElement {
    connectedCallback() {
      if (this.dataset.prepared) return;
      this.dataset.prepared = 'true';
      const source = this.querySelector('[data-product-copy-source]');
      const details = this.querySelector('[data-product-details]');
      const destination = this.querySelector('[data-product-details-content]');
      if (!source || !details || !destination) return;
      const disclaimer = /(?:please\s+note\s*:\s*|note\s*:\s*|handmade\s*:\s*)?(?:our jewels are handmade in Italy[^.!]*artisanal techniques[^.!]*[.!]|each jewel is handcrafted in Italy[^.!]*artisanal techniques[^.!]*[.!]|(?:due to[^.!]*|for this reason,\s*)?carats and gold weight[^.!]*vary[.!])/gi;
      source.querySelectorAll('p,li').forEach(node => {
        const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
        const segments = []; let text = '', current;
        while ((current = walker.nextNode())) { segments.push({node: current, start: text.length, end: text.length + current.length}); text += current.data; }
        const matches = [...text.matchAll(disclaimer)].reverse();
        for (const match of matches) {
          const start = segments.find(s => s.end > match.index);
          const end = segments.find(s => s.end >= match.index + match[0].length);
          if (!start || !end) continue;
          const range = document.createRange();
          range.setStart(start.node, match.index - start.start);
          range.setEnd(end.node, match.index + match[0].length - end.start);
          range.deleteContents();
        }
        if (!node.textContent.trim()) node.remove();
      });
      source.querySelectorAll('*').forEach(node => {
        node.removeAttribute('class');
        node.removeAttribute('style');
        [...node.attributes].filter(attribute => attribute.name.startsWith('data-')).forEach(attribute => node.removeAttribute(attribute.name));
      });
      source.querySelectorAll('p,li').forEach(node => {
        const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
        let current;
        while ((current = walker.nextNode())) {
          current.data = current.data.replace(/,?\s*this exquisite (?:ring|piece|necklace|bracelet|jewel) embodies elegance and sophistication\.?/gi, '.').replace(/Crafted with elegance,\s*/gi, '').replace(/This exquisite (necklace|ring|bracelet|piece) is crafted/gi, 'This $1 is crafted');
        }
      });
      const generic = /^(description|details|product details|features|key features|additional details|specifications|diamond specifications)\s*:?$/i;
      const specifications = /^(material|metal|gemstones?|diamonds?|white diamonds?|champagne diamonds?|length|width|dimensions|size|flower size|reference|sku|product code|paving|stone quality|more details)\s*:/i;
      const children = [...source.children];
      let introShown = false;
      children.forEach(node => {
        const text = node.textContent.trim();
        if (!text) { node.remove(); return; }
        if (generic.test(text) && !node.querySelector('ul,ol,table')) { node.remove(); return; }
        if (node.matches('ul,ol,table') || specifications.test(text)) {
          destination.append(node);
          return;
        }
        if (node.matches('h1,h2,h3,h4,h5,h6')) {
          const paragraph = document.createElement('p');
          while (node.firstChild) paragraph.append(node.firstChild);
          node.replaceWith(paragraph);
          node = paragraph;
        }
        if (this.dataset.online === 'false') {
          const labelOnly = node.matches('p') && node.children.length === 1 && node.firstElementChild.matches('strong,b') && node.firstElementChild.textContent.trim() === text;
          if (labelOnly || introShown) destination.append(node);
          else introShown = true;
        }
      });
      const detailRank = node => {
        const text = node.textContent.trim();
        if (/^(material|metal)\s*:/i.test(text)) return 0;
        if (/^(gemstones?|diamonds?|white diamonds?|champagne diamonds?|stone quality|paving)\s*:/i.test(text)) return 1;
        if (/^(length|width|dimensions|size|flower size)\s*:/i.test(text)) return 2;
        if (/^(reference|sku|product code)\s*:/i.test(text)) return 4;
        return 3;
      };
      destination.querySelectorAll('ul,ol').forEach(list => {
        [...list.children].sort((a,b) => detailRank(a)-detailRank(b)).forEach(node => list.append(node));
      });
      [...destination.children].sort((a,b) => detailRank(a)-detailRank(b)).forEach(node => destination.append(node));
      if (destination.children.length) {
        details.hidden = false;
        details.open = false;
      }
      if (!source.textContent.trim()) this.querySelector('.hartfield-product-copy--intro').hidden = true;
    }
  }
  customElements.define('hartfield-product-copy', HartfieldProductCopy);
})();
